import { useState } from 'react';

const faqs = [
  {
    question: '爱丫爱丫影院是否需要注册才能观看？',
    answer: '不需要注册！爱丫爱丫影院所有高清电影和免费电视剧均可直接在线观看，无需注册登录，无需任何费用，真正做到打开即看。',
  },
  {
    question: '观看电影时会有广告吗？',
    answer: '完全不会！爱丫爱丫影院承诺无广告播放体验。无论您观看任何电影、电视剧，全程都不会有任何广告打断您的观影体验，秒开看剧，不缓冲。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '爱丫爱丫影院支持电脑、平板、手机等多种设备在线观看。网站采用响应式设计，自适应各种屏幕尺寸，无论在家还是外出，都能享受流畅的观影体验。',
  },
  {
    question: '视频画质如何？会不会卡顿？',
    answer: '我们提供高清画质播放，采用先进的视频加速技术，确保流畅播放。只要您的网络正常，就能享受极速观影体验，不卡顿、不缓冲，让观影成为享受。',
  },
  {
    question: '网站的电影资源多久更新一次？',
    answer: '爱丫爱丫影院每日更新最新的电影和电视剧资源。无论是院线大片、热播电视剧还是经典老片，我们都会在第一时间上线，确保您不错过任何精彩内容。',
  },
  {
    question: '遇到播放问题怎么办？',
    answer: '如果您在观影过程中遇到任何问题，可以通过关于我们页面的联系方式与我们取得联系。我们的技术团队会尽快帮您解决播放问题，确保您的观影体验。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[800px] mx-auto">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-500">关于爱丫爱丫影院的常见疑问解答</p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}